"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AuctionTypes = void 0;
const AuctionTypes = exports.AuctionTypes = {
  Biddable: [13, 14, 16, 25, 37, 38],
  BuyItNowOfferCounterOffer: [15],
  BuyItNowNonCloseout: [20, 39],
  MemberOfferCounterOffer: [33]
};